module.exports = __webpack_public_path__ + "static/media/avera.0b9cbe58.svg";